export const maquetaTpl = {
  modalDatos: {
    regTitle: `Dane rejestracji`,
    paymentMethod: `Sposób płatności`,
    paymentDate: `Data płatności`,
    guestCount: `Liczba gości`,
    unspecified: `Nie podano`,
    pay: {
      DESTI: `Płatność na miejscu`,
      EFECT: `Gotówka`,
      MOVIL: `Płatność mobilna`,
      OTRO: `Inne sposoby płatności`,
      PLATF: `Platforma płatnicza`,
      TARJT: `Karta kredytowa`,
      TRANS: `Przelew bankowy`,
      TREG: `Karta podarunkowa`,
    },
  },
  whatsapp: {
    title: `Dostęp na wyłączność do WhatsApp Business`,
    body: `Aby korzystać z funkcji WhatsApp Business, wymagana jest aktywna subskrypcja WhatsApp Business Personal. Ta opcja daje Panu/Pani dodatkowe narzędzia i zaawansowane funkcje, które usprawnią prowadzenie firmy.`,
  },
  nav: {
    welcome: `Witamy`,
    manager: `Menedżer`,
    logout: `Wyloguj się`,
    logoutError: `Niestety podczas wylogowywania wystąpił błąd`,
  },
  subnav: {
    home: `Start`,
    clients: `Klienci`,
    prices: `Ceny`,
    payments: `Płatności`,
    userManagement: `Zarządzanie użytkownikami`,
  },
};
